const typeNamespace = 'USER_';

export const SUB_USER_LIST = `${typeNamespace}SUB_USER_LIST`;